import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import isNil from 'lodash/isNil'
import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import useGaloMonitorApi from '@galo-monitor/services/hooks/useGaloMonitorApi'
import { CircularLoader } from '@galo-monitor/web-components/Loader'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import FarmInfo from './tabs/FarmInfo'

const SelectedFarmScreen = () => {
  const { routes, urlHasPermission } = useRoutes()
  const { farmId } = useParams()
  const t = useT()

  const {
    data: currentFarmData,
    error,
    mutate
  } = useGaloMonitorApi(`/companies/farms/accounts/${ farmId }`)

  const isLoadingFarmData = useMemo(() => !currentFarmData && !error, [currentFarmData, error])

  const farmName = useMemo(
    () => !isNil(currentFarmData)
      ? currentFarmData.name
      : null,
    [currentFarmData]
  )

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        if (urlHasPermission(tab.slug, 'company')) {
          response.push(tab)
        }
      }

      addTab({
        route: '',
        slug: 'gerenciamento-de-contas-farm',
        title: toUpper(t('registration information')),
        Component: FarmInfo,
        ComponentProps: {
          farmData: currentFarmData,
          mutateFarmData: mutate
        }
      })

      return response
    },
    [currentFarmData, mutate, t, urlHasPermission]
  )

  const crumbs = useMemo(() => [
    {
      title: routes.farms.title,
      key: 'farms-screen',
      url: '/farms',
      active: true
    },
    {
      title: farmName,
      key: 'selected-farm-screen',
      url: `/farms/${ farmId }`,
      active: true
    }
  ], [farmId, farmName, routes.farms.title])

  return isLoadingFarmData ? (
    <CircularLoader label={ t('loading company data') } />
  ) : (
    <Screen title={ farmName } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default SelectedFarmScreen
